
<BasicConfigurator :value="imagesForBasicConfigurator"
                   :product="product"
                   :configuration-valid="configurationValid"
                   @addedToBasket="addedToBasket"
                   @error="onError"
                   @reset="resetConfiguration">
  <v-stepper v-model="step" vertical :non-linear="true" class="configurationStepper">
    <v-stepper-step v-if="personSelectionNeeded"
                    :complete="step > personSelectionStep"
                    :step="personSelectionStep"
                    edit-icon="check"
                    editable
    >{{ $t('CONFIGURATOR_SELECT_CODE') }}
      <small>{{ $t('CONFIGURATOR_SELECT_PERSON_SUBTITLE') }}</small>
    </v-stepper-step>
    <v-stepper-content v-if="personSelectionNeeded" :step="personSelectionStep">
      <PersonSelector v-model="personIndex" :persons="eligiblePersons" @select="onPersonSelect"/>
    </v-stepper-content>

    <v-stepper-step
        :complete="step > imageSelectionStep"
        :step="imageSelectionStep"
        edit-icon="check"
    >{{ $t('CONFIGURATOR_PREVIEW') }}
    </v-stepper-step>
    <v-stepper-content :step="imageSelectionStep" class="imageStepperContent">
      <ImageSelector :value="selectedImages"
                     :images="selectedImages"
                     :select-all="true"
                     :filter="filter"
                     :scrollable-container-parent-layers="1"
                     ref="imageSelector"
      />
    </v-stepper-content>
  </v-stepper>
</BasicConfigurator>
